import { ref, onMounted } from 'vue';
import http from '@/http.js';
import eventBus from '@/eventBus.js';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function useEditerJustifWithoutConnexion(props, emit) {
    const idJustificationAnomalie = ref('');
    const justificationText = ref('');
    const type = ref('');
    const validJustification = ref('');
    const commentaire = ref('');
    const isVisible = ref({
        justif: false,
        validation: false,
    });

    const fetchJustificationData = async () => {
        if (props.idAnomalie !== undefined) {
            try {
                const data = await http.loadJustificationOffline(props.idAnomalie);
                idJustificationAnomalie.value = data.idJustificationAnomalie;
                type.value = data.type;
                justificationText.value = data.justificationText;
                validJustification.value = data.validJustification;
                commentaire.value = data.commentaire;

                isVisible.value.justif = type.value === 'justification';
                isVisible.value.validation = type.value === 'correction';
            } catch (error) {
                console.error('Erreur lors du chargement de la justification:', error);
            }
        }
    };

    const toggleVisibility = (section, visible) => {
        isVisible.value[section] = visible;
    };

    const deleteJustificationOffline = async () => {
        if (confirm(`Voulez-vous vraiment supprimer la justification : ${idJustificationAnomalie.value}`)) {
            try {
                await http.deleteJustificationOffline(idJustificationAnomalie.value);
                eventBus.emit('reloadAnomaliesToJustifWithoutCo');
                eventBus.emit('reloadRapportByCode');
                emit('close');
                emit('notification', {
                    showNotification: true,
                    toastMessage: `Justification ${idJustificationAnomalie.value} supprimée avec succès`,
                    toastType: "success",
                });
            } catch (error) {
                console.error('Erreur lors de la suppression de la justification:', error);
            }
        }
    };

    const updateJustificationOffline = async () => {
        const justificationData = {
            idJustificationAnomalie: idJustificationAnomalie.value,
            type: type.value,
            justificationText: justificationText.value,
            idLigneAnomalie: props.idAnomalie,
            validJustification: validJustification.value,
            commentaire: commentaire.value,
        };

        try {
            await http.updateJustificationOffline(justificationData);
            eventBus.emit('reloadAnomaliesToJustifWithoutCo');
            eventBus.emit('reloadRapportByCode');
            emit('close');
            emit('notification', {
                showNotification: true,
                toastMessage: 'Justification modifiée avec succès',
                toastType: "success",
            });
        } catch (error) {
            console.error('Erreur lors de la mise à jour de la justification:', error);
        }
    };

    onMounted(() => {
        fetchJustificationData();
    });

    return {
        idJustificationAnomalie,
        justificationText,
        type,
        validJustification,
        commentaire,
        isVisible,
        toggleVisibility,
        deleteJustificationOffline,
        updateJustificationOffline,
    };
}
